import { ObjectHelpers } from "../../helpers/object-helpers";

export class AdvancedOEPStateModel {
    public open = false
    public expandedTable = false
    public expandedLimitIn = false
    public defaultTradeMenu = '';
    public top = '';
    public left = '';
    public account = '';
    public displayCFCPercentage = true;
    public autoSend = false;
    public tif = '';
    public cancelAction = '';

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }
}